import React, { useCallback, useEffect, useState } from 'react';

import { NoImprovementScreen } from '@atlassian/generative-ai-modal/screens/NoImprovement';

import { resetSessionState } from '../../../../pm-plugins/ai-session-context/commands';
import { useContentComponentContext } from '../../../hooks/useContentComponentContext';
import { Container } from '../Container';
import type { Action } from '../hooks/useUIState';
import type { SessionUIComponentProps } from '../SessionUIComponent';

export function NoImprovementSessionScreen({
	api,
	appearance,
	dispatch,
}: Omit<SessionUIComponentProps, 'providerFactory'> & {
	dispatch: React.Dispatch<Action>;
}): React.JSX.Element {
	const [isHidden, setIsHidden] = useState(false);
	const { endExperience } = useContentComponentContext();

	const onceFade = useCallback(() => {
		api?.core?.actions.execute(resetSessionState());
		endExperience();
		dispatch({ type: 'terminate' });
	}, [api, endExperience, dispatch]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsHidden(true);
		}, 1000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<Container appearance={appearance}>
			<NoImprovementScreen isHidden={isHidden} onceFade={onceFade} appearance={appearance} />
		</Container>
	);
}
